/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_BLOGS (state, blogs) {
    state.blogs = blogs
  },
  REMOVE_BLOG (state, itemId) {
    const userIndex = state.blogs.findIndex((u) => u.id === itemId)
    state.blogs.splice(userIndex, 1)
  }
}
